import React, { Component } from "react";
import { Card } from "react-bootstrap-v5";
import "react-bootstrap-typeahead/css/Typeahead.css";

const formatLabel = (key) =>
  key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

const renderDutyTaxOrdered = (dutyTaxArray) => {
  if (!Array.isArray(dutyTaxArray) || dutyTaxArray.length === 0) return null;

  const order = [
    "insurance",
    "freight",
    "cif",
    "duty",
    "vat",
    "caf",
    "additional_charge",
    "total_duty_tax",
  ];

  const item = dutyTaxArray[0];

  return (
    <ul className="ps-4">
      {order.map((key) =>
        item[key] !== undefined ? (
          <li key={key} style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: "bold" }}>{formatLabel(key)}:</span>{" "}
            <span style={{ color: item[key] === 0 ? "#888" : "#000" }}>
              {item[key]}
            </span>
          </li>
        ) : null
      )}
    </ul>
  );
};

const renderStyledList = (
  data,
  level = 0,
  airData = {},
  deliveryType = "",
  visited = new Set()
) => {
  if (!data || typeof data !== "object") return null;

  if (Array.isArray(data)) {
    return (
      <>
        {data.map((item, index) => (
          <React.Fragment key={index}>
            {renderStyledList(item, level, airData, deliveryType, visited)}
          </React.Fragment>
        ))}
      </>
    );
  }

  const listItems = [];
  const entries = Object.entries(data);
  const breakdownPath = airData?.breakdown?.[deliveryType];
  const totalAdditionalCharges = breakdownPath?.total_additional_charges;

  // Add Freight Amount first
  if (level === 0 && breakdownPath?.freight_amnount !== undefined) {
    listItems.push(
      <li key="freight-amount">
        <strong>Freight Amount:</strong>{" "}
        <span>{breakdownPath.freight_amnount}</span>
      </li>
    );
  }

  let dutyTaxRendered = false; // Flag to ensure dutyTax is rendered only once

  entries.forEach(([key, value], index) => {
    // Skip rendering dutyTax if it's already rendered
    if (key === "dutyTax" && !dutyTaxRendered) {
      listItems.push(
        <li key="duty-tax">
          <strong>DutyTax:</strong>
          {renderDutyTaxOrdered(value)}
        </li>
      );
      dutyTaxRendered = true; // Set the flag to true after rendering dutyTax
    } else if (key !== "dutyTax") {
      listItems.push(
        <li key={`${key}-${index}`}>
          <strong>{formatLabel(key)}:</strong>{" "}
          {typeof value === "object" && value !== null ? (
            renderStyledList(value, level + 1, airData, deliveryType, visited)
          ) : (
            <span>{value}</span>
          )}
        </li>
      );
    }

    if (
      key === "attr" &&
      totalAdditionalCharges !== undefined &&
      level === 0
    ) {
      listItems.push(
        <li key="total-additional-charges">
          <strong>Total Additional Charges:</strong>{" "}
          <span style={{ color: totalAdditionalCharges === 0 ? "#888" : "#000" }}>
            {totalAdditionalCharges}
          </span>
        </li>
      );
    }
  });

  return (
    <ul
      style={{ listStyleType: "disc", paddingLeft: `${20 * level}px` }}
      className="ps-4"
    >
      {listItems}
    </ul>
  );
};

class QuoteBreakedown extends Component {
  render() {
    const { jobData } = this.props;

    const keyMap = {
      AIR: "quote_request_airs",
      COURIER: "quote_request_couriers",
      LAND: "quote_request_lands",
      SEA: "quote_request_seas",
    };

    const serviceType = jobData?.shipment_details?.servic_type || "";
    const match = Object.keys(keyMap).find((type) =>
      serviceType.includes(type)
    );
    const matchedKey = match ? keyMap[match] : null;
    const airData = jobData[matchedKey] || {};
    const breakdown = airData?.breakdown;

    return (
      <Card>
        <div className="card-header bg-light">
          <h4>Quote Breakdown</h4>
        </div>
        {breakdown ? (
          <Card.Body>
            <div
              className="ps-4 col-sm-6"
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "16px",
                backgroundColor: "#fafafa",
              }}
            >
              {jobData?.shipment_details?.shipment_mode.includes("PORT") && (
                <>
                  <h5 className="text-primary mb-2">Port Delivery</h5>
                  {renderStyledList(
                    breakdown?.port_delivery?.additional_charges,
                    0,
                    airData,
                    "port_delivery"
                  )}
                </>
              )}
              {jobData?.shipment_details?.shipment_mode.includes("DOOR") && (
                <>
                  <h5 className="text-primary mb-2">Door Delivery</h5>
                  {renderStyledList(
                    breakdown?.door_delivery?.additional_charges,
                    0,
                    airData,
                    "door_delivery"
                  )}
                </>
              )}
            </div>
          </Card.Body>
        ) : (
          <div className="text-center p-3">Data not available</div>
        )}
      </Card>
    );
  }
}

export default QuoteBreakedown;






